<template>
  <v-app-bar
    app
    flat
    :clipped-left="isClippedLeft"
    :clipped-right="isClippedRight"
    v-if="isVisibleHeader"
    v-bind="bindStyle"
    :dense="isDense"
    :prominent="isProminent"
    :hide-on-scroll="isHideOnScroll"
    :shrink-on-scroll="isShrinkOnScroll"
  >
    <v-sheet
      color="transparent"
      v-if="isClippedOver || $vuetify.breakpoint.mdAndDown"
    >
      <v-list-item class="pl-0">
          <v-list-item-content v-if="$vuetify.breakpoint.mdAndUp">
          
          <v-list-item-title class="text-h6 primary--text"
            ><img src="/static/assets/apex.png" /></v-list-item-title
          >
        </v-list-item-content>
        <v-list-item-action v-if="$vuetify.breakpoint.lgAndUp">
          <v-btn
            @click.stop="toggleMiniVariant"
            small
            fab
            :class="!bindStyle.color ? 'neu-glow' : ''"
          >
            <v-icon
              :color="!bindStyle.color ? 'primary' : bindStyle.color"
              v-if="isMinSideNav"
              >double_arrow</v-icon
            >
            <v-icon
              :color="!bindStyle.color ? 'primary' : bindStyle.color"
              v-else
              >menu_open</v-icon
            >
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-sheet>
    <div v-if="$vuetify.breakpoint.lgAndUp">
      <!-- toggle Mini variant -->
      <v-btn
        @click.stop="toggleMiniVariant"
        small
        fab
        :class="!bindStyle.color ? 'neu-glow' : ''"
        v-if="!isClippedOver"
      >
        <v-icon
          :color="!bindStyle.color ? 'primary' : bindStyle.color"
          v-if="isMinSideNav"
          >double_arrow</v-icon
        >
        <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color" v-else
          >menu_open</v-icon
        >
      </v-btn>
      <!-- Contact APP -->
      <!-- <v-btn
        small
        fab
        to="/app/contacts"
        :class="!bindStyle.color ? 'neu-glow' : ''"
        active-class="neu-glow-inset"
        class="mx-3"
      >
        <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color"
          >contacts</v-icon
        >
      </v-btn> -->
      <!-- Chat APP -->
      <!-- <v-btn
        small
        fab
        to="/app/chat"
        :class="!bindStyle.color ? 'neu-glow' : ''"
        active-class="neu-glow-inset"
      >
        <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color"
          >chat</v-icon
        >
      </v-btn> -->
    </div>
    <v-spacer />
    <v-btn
      v-if="$vuetify.breakpoint.mdAndDown"
      class="mr-3"
      small
      fab
      :class="!bindStyle.color ? 'neu-glow' : ''"
      @click="handleSidenavDrawer()"
    >
      <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color"
        >menu</v-icon
      >
    </v-btn>    
 
    <!-- User Profile Menu -->
    <v-menu offset-y min-width="160">
      <template v-slot:activator="{ on }">
        
        <v-btn v-on="on" class="mr-0" text style="text-transform:inherit !important;">       
          <span class="mr-5 ml-5"> Hi, {{ account.data.user.userName }}!</span>   
          <v-avatar size="40" v-if="bindStyle.color">
            <!-- <v-img :src="authUser.avatar"></v-img> -->
            
            <v-icon>settings</v-icon>
          </v-avatar>
          <v-icon v-else>settings</v-icon>
          <!-- <vuse-avatar size="40" :src="authUser.avatar" v-else /> -->          
        </v-btn>
      </template>
      <v-list nav dense class="neu-glow-primary with-radius">
        <template v-for="(item, index) in items">
          <v-divider v-if="item.divider" :key="index"></v-divider>
          <v-list-item
            :key="index"
            @click="item.onClick()"
            v-show="item.onlyAdmin && isAdmin || !item.onlyAdmin"
            v-else
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { availableLocale } from "@/config/locale";

export default {
  props: {
    handleSettingsDrawer: Function,
  },
  created() {},
  data() {
    return {
      items: [
        {
          icon: "person",
          text: "Account",
          onClick: () => {
            this.$router.push({
              path: "/account",
            });
          },
          onlyAdmin: false,
        },
        {
          icon: "power_settings_new",
          text: `Logout`,
          onClick: () => {
            this.$store.dispatch("account/logout");
            this.$router.push({
              path: "/login",
            });
          },
          onlyAdmin: false
        },
      ],
      langs: availableLocale,
    };
  },
  computed: {
    activeItemStyle: (state) => state.activeMenuStyle,
    ...mapGetters("navigations", [
      "isVisibleHeader",
      "isSidenavPostionRight",
      "isClippedOver",
      "isMinSideNav",
      "isDense",
      "isProminent",
      "isHideOnScroll",
      "isShrinkOnScroll",
      "isFloating",
    ]),
    ...mapGetters("scheme", ["header"]),
    ...mapGetters(["locale"]),
    ...mapState({
      account: (state) => state.account,
      isAdmin: (state) => state.account.data.isAdmin,
    }),
    isClippedRight() {
      return this.isClippedOver && this.isSidenavPostionRight;
    },
    isClippedLeft() {
      return this.isClippedOver && !this.isSidenavPostionRight;
    },
    bindStyle() {
      const { color, dark, classes } = this.header;
      return {
        class: {
          "vuse-header": true,
          "with-radius": true,
          [classes]: true,
          "mx-6 mt-3": this.isFloating && !this.isClippedOver,
        },
        dark,
        color,
      };
    },
    currentLocaleImg() {
      return this.langs.find((item) => item.value === this.locale).img;
    },
  },
  methods: {
    toggleMiniVariant() {
      this.$store.dispatch("navigations/setMiniVariant");
    },
    handleSidenavDrawer() {
      this.$store.dispatch("navigations/setSidenavVisibility");
    },
    handleInternationalization(value) {
      this.$store.dispatch("setLocale", value);
    },
  },
};
</script>
